<template>
  <div class="sf-el short-answer-input">
    <div class="sf-short-answer">
      <label class="sf-el__label">
        {{ label }}
        <span v-if="required" class="sf-el__required">*</span>
      </label>
      <p v-if="caption" class="sf-el__caption">{{ caption }}</p>
      <input type="text" v-model="value" :placeholder="placeholder" />
    </div>
  </div>
</template>

<script>
  import { watch, ref } from 'vue';

  export default {
    name: 'ShortAnswerElement',
    props: {
      label: String,
      description: String,
      caption: String,
      name: String,
      modelValue: {
        type: String,
        default: '',
      },
      required: Boolean,
      placeholder: String,
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const value = ref(props.modelValue);

      // Watch for external changes to modelValue
      watch(
        () => props.modelValue,
        (newValue) => {
          value.value = newValue;
        }
      );

      // Watch for internal changes to value
      watch(value, (newValue) => {
        emit('update:modelValue', newValue);
      });

      return {
        value,
      };
    },
  };
</script>

<style scoped lang="scss">
  .sf-short-answer {
  }
</style>
